import React from 'react'
import PageWrapper from '../../components/PageWrapper'

export default function Home() {
  return <PageWrapper title="Home">HOME</PageWrapper>
}
